import postHttp from '../../plugin/extendFn/postHttp'
import loginService from '../../plugin/extendFn/loginService'
import AppSetting from '../../AppSetting';


async function httpGard(to, from, next) {
  //  let href= window.location.href;
  //  if( href.includes("https://"))
  //  {
  //   href.replace("https://","http://");
  //   window.location.href=href;
  //  }
  //  else
   {
    next();
   }
}

export default httpGard


// WEBPACK FOOTER //
// ./src/router/gard/httpGard.js